module.exports = __webpack_public_path__ + "img/graphic-2.40f3b73c.png";